import { useAuth } from "react-oidc-context";
import { useCallback, useRef } from "react";

import NitroFilter from "../NitroFilter";
import NitroService from "../../utils/nitro.service";

const CompanyFilter = ({
  locationId,
  value,
  setValue,
  config,
  disabled,
  size,
  isMobile,
  type = "autocomplete",
  variant,
  placeholder = "Company name",
}: {
  locationId?: string;
  value: string;
  setValue: (value: string) => void;
  config?: {
    customPaper?: boolean;
    shadow?: boolean;
    opaque?: boolean;
    autoFocus?: boolean;
    inputRef?: React.MutableRefObject<any> | null;
    valueRequired?: boolean;
  };
  disabled?: boolean;
  size?: "small" | "medium";
  isMobile?: boolean;
  type?: "autocomplete" | "popup";
  variant?: "standard" | "outlined" | "filled";
  placeholder?: string;
}) => {
  const auth = useAuth();
  const user = `${auth.user?.profile.given_name} ${auth.user?.profile.family_name}`;
  const ref = useRef<HTMLInputElement | null>(null);

  const getRecords = useCallback(
    async (v: string) => {
      const hasValidLocationId =
        typeof locationId === "string" && locationId.length > 0;
      const shouldUseLocationSpecificSearch =
        placeholder === "Competitor company name";

      if (hasValidLocationId && shouldUseLocationSpecificSearch) {
        const records = await NitroService.getOccupantsByLocationId({
          locationId,
        });
        return [
          { label: "", value: "" }, // Consider if this default empty option is always needed
          ...records.map((r) => ({ label: r.name, value: r.name })),
        ];
      }

      const records = await NitroService.getPartiesLike(v, user);
      return [
        { label: "", value: "" },
        ...records.map((r) => ({ label: r.name, value: r.name })),
      ];
    },
    [locationId, placeholder, user]
  );

  return (
    <NitroFilter
      data={{
        getRecords,
      }}
      value={value}
      setValue={setValue}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      config={{ ...config, inputRef: config?.inputRef || ref, hideDropdownIcon: true }}
      type={type}
      isMobile={isMobile}
      variant={variant}
    />
  );
};

export default CompanyFilter;
